import React, { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import { Logo } from "../../assets/images";
import {
  CallOutlined,
  WhatsApp,
} from "@mui/icons-material";

const DesktopNav = () => (
  <div className="hidden md:flex space-x-6 rtl:space-x-reverse">
    <NavLink to="/">الرئيسية</NavLink>
    <NavLink to="/about-us">من نحن</NavLink>
    <NavLink to="/services">الخدمات</NavLink>
    <NavLink to="/projects">مشاريعنا</NavLink>
    <NavLink to="/prices">انظمة التشطيب</NavLink>
    <NavLink to="/contact-us">تواصل معنا</NavLink>
    {/* واتساب (خارجي) */}
    <a
      href="https://wa.me/201003234531"
      target="_blank"
      rel="noopener noreferrer"
      className="relative text-white hover:text-green-400 group flex items-center gap-1"
    >
      <WhatsApp />
      واتساب
      <div className="absolute bottom-0 left-0 w-full h-[2px] bg-green-400 scale-x-0 group-hover:scale-x-100 transform origin-right transition-all duration-300"></div>
    </a>
  </div>
);

const MobileNav = ({
  isOpen,
  toggleMenu,
}: {
  isOpen: boolean;
  toggleMenu: () => void;
}) => (
  <div
    className={`fixed top-0 left-0 w-full h-full bg-[#baad87] text-white p-6 flex flex-col space-y-6 z-50 transition-all duration-500 ease-in-out ${
      isOpen ? "translate-y-0" : "translate-y-full"
    }`}
  >
    <button
      className="self-end text-white text-2xl p-2 "
      onClick={toggleMenu}
      aria-label="Close menu"
    >
      <CloseIcon />
    </button>
    <Link
      to="/"
      onClick={toggleMenu}
      className="text-xl font-bold hover:text-[#9E9195]"
    >
      الرئيسية
    </Link>
    <Link
      to="/about-us"
      onClick={toggleMenu}
      className="text-xl font-bold hover:text-[#9E9195]"
    >
      من نحن
    </Link>
    <Link
      to="/services"
      onClick={toggleMenu}
      className="text-xl font-bold hover:text-[#9E9195]"
    >
      الخدمات
    </Link>
    <Link
      to="/projects"
      onClick={toggleMenu}
      className="text-xl font-bold hover:text-[#9E9195]"
    >
      مشاريعنا
    </Link>
    <Link
      to="/prices"
      onClick={toggleMenu}
      className="text-xl font-bold hover:text-[#9E9195]"
    >
      انظمة التشطيب
    </Link>
    <Link
      to="/contact-us"
      onClick={toggleMenu}
      className="text-xl font-bold hover:text-[#9E9195]"
    >
      تواصل معنا
    </Link>
    {/* واتساب (خارجي) */}
    <a
      href="https://wa.me/201003234531"
      target="_blank"
      rel="noopener noreferrer"
      onClick={toggleMenu}
      className="text-xl font-bold hover:text-green-400 flex items-center gap-2"
    >
      <WhatsApp />
      واتساب
    </a>
  </div>
);

const NavLink = ({
  to,
  children,
}: {
  to: string;
  children: React.ReactNode;
}) => (
  <Link to={to} className="relative text-white hover:text-[#9E9195] group">
    {children}
    <div className="absolute bottom-0 left-0 w-full h-[2px] bg-[#9E9195] scale-x-0 group-hover:scale-x-100 transform origin-right transition-all duration-300"></div>
  </Link>
);

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bg-[#baad87] text-white px-4">
      <div
        className="container mx-auto flex justify-between items-center"
        dir="rtl"
      >
        {/* Logo Section */}
        <Link to={"/"}>
          <img
            className="w-[80px] h-[80px] filter grayscale"
            src={Logo}
            alt="Logo"
          />
        </Link>

        {/* Desktop Menu */}
        <DesktopNav />

        {/* Mobile Hamburger Icon */}
        <div className="md:hidden flex gap-2 ">
          <a
            href="tel:+0201003234531"
            aria-label="Call 01003234531"
            className="border-2 border-white p-2"
          >
            <CallOutlined />
          </a>
          {isOpen ? (
            <CloseIcon onClick={toggleMenu} />
          ) : (
            <div className="border-2 border-white p-2">
              <MenuIcon onClick={toggleMenu} className="" />
            </div>
          )}
        </div>
      </div>

      {/* Mobile Menu (Dropdown) */}
      <MobileNav isOpen={isOpen} toggleMenu={toggleMenu} />
    </nav>
  );
};

export default Navbar;
